module.exports = __webpack_public_path__ + "img/huawei.3894b69a.svg";